import React, { useState } from "react";
import { useNavigate } from "react-router";

import SettingsTutorial from "../SettingsTutorial";

import { SonicDBEntryData } from "../../../../common/classes/SonicDBEntry";
import BackBar from "../../../../common/nav/BackBar";
import SettingsItem from "../../../../common/mypage/user-settings/SettingsItem";

import ImageTeamMember from "../../../../assets/img/service/team_member.webp";

import styles from "../../../../common/mypage/user-settings/Settings.module.scss";

type Props = {
  backBarTitle?: string;
  members?: Array<SonicDBEntryData>;
  ownerId?: string;
  handlePublish: (id?: string) => void;
  handlePrivate: (id?: string) => void;
};

const TeamMembersList: React.FC<Props> = ({
  backBarTitle,
  members,
  ownerId,
  handlePublish,
  handlePrivate,
}) => {
  const navigate = useNavigate();

  const [currentMenu, setCurrentMenu] = useState<number | null>(null);

  const toggleMenu = (i: number) => {
    if (i === currentMenu) {
      setCurrentMenu(null);
    } else {
      setCurrentMenu(i);
    }
  };

  return (
    <>
      <div className={styles["p-dbsettings"]}>
        <div className={styles["p-dbsettings__wrapper"]}>
          <BackBar
            title={backBarTitle}
            editable={false}
            handleClose={() => navigate(-1)}
          />
          <div className={styles["p-projectSettings__list"]}>
            <div className={styles["p-projectSettings__list-title"]}>
              チームメンバー一覧
            </div>
            {members && members?.length > 0 ? (
              members.map((member, i) => (
                <SettingsItem
                  key={i}
                  page_type="プロフィール"
                  id={member.id}
                  img_src={member.imgs?.[0]?.thumbnail?.url}
                  name={member.name}
                  type={{
                    color: member.team?.[0]?.color,
                    name: member.player_type?.[0]?.name,
                  }}
                  status={member.status}
                  handleMenu={() => toggleMenu(i)}
                  handlePublish={handlePublish}
                  handlePrivate={handlePrivate}
                  edit_link={`/mypage/settings/${member.id}`}
                  detail_link={`/person/${member.id}`}
                  isMenuOpen={currentMenu === i ? true : false}
                  isOwner={ownerId === member.owner ? true : false}
                  verified={member.verified}
                />
              ))
            ) : (
              <SettingsTutorial
                img_src={ImageTeamMember}
                title="チームメンバーを追加するには？"
                explanation="チームメンバーの追加は、プロフィール作成・編集から、所属チームを選択することで可能です。"
                link="/mypage/settings"
                link_text="プロフィール設定ページへ"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamMembersList;
